/* ==================================================
  カスタム:ピックアップ PCスライダー
  prev-next-buttons の prev-next:prev / :next イベントを受けて
  グリッドをカラム数ぶん横スクロール。矢印の活性状態はスクロール位置で切替。
  矢印の縦位置は画像の中心に追従させる。
===================================================*/
if (!customElements.get('c-pickup-slider')) {
  customElements.define(
    'c-pickup-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.c_pickup__grid');
        this.prevButton = this.querySelector('.c_pickup__arrow--prev');
        this.nextButton = this.querySelector('.c_pickup__arrow--next');
        if (!this.grid) return;

        this._onPrev = () => this._scrollByPage(-1);
        this._onNext = () => this._scrollByPage(1);
        this._onScroll = () => this._requestUpdate();
        this._onResize = () => this._requestUpdate();

        this.addEventListener('prev-next:prev', this._onPrev);
        this.addEventListener('prev-next:next', this._onNext);
        this.grid.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize);

        this._requestUpdate();
        /* 画像読み込み後に縦位置がずれるため再計算 */
        window.addEventListener('load', this._onResize, { once: true });
      }

      disconnectedCallback() {
        this.removeEventListener('prev-next:prev', this._onPrev);
        this.removeEventListener('prev-next:next', this._onNext);
        this.grid?.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onResize);
        if (this._rafId) cancelAnimationFrame(this._rafId);
      }

      /* カラム数ぶん（表示領域1画面）スクロール */
      _scrollByPage(direction) {
        try {
          const gap = parseInt(getComputedStyle(this.grid).columnGap) || 0;
          const amount = this.grid.clientWidth + gap;
          this.grid.scrollBy({ left: amount * direction, behavior: 'smooth' });
        } catch (error) {
          console.error('[c_pickup]', 'Failed to scroll slider', error);
        }
      }

      _requestUpdate() {
        if (this._rafId) return;
        this._rafId = requestAnimationFrame(() => {
          this._rafId = null;
          this._updateArrows();
          this._updateArrowPosition();
        });
      }

      /* 先頭/末尾カードの描画位置で前後ボタンの活性を切替
         （scroll-snap で scrollLeft が最大値に届かない場合があるため位置で判定） */
      _updateArrows() {
        if (!this.prevButton || !this.nextButton) return;
        const cards = this.grid.children;
        if (!cards.length) return;

        const TOLERANCE = 1;
        const gridRect = this.grid.getBoundingClientRect();
        const firstRect = cards[0].getBoundingClientRect();
        const lastRect = cards[cards.length - 1].getBoundingClientRect();

        this.prevButton.disabled = firstRect.left >= gridRect.left - TOLERANCE;
        this.nextButton.disabled = lastRect.right <= gridRect.right + TOLERANCE;
      }

      /* 矢印の縦位置を画像の中心に合わせる */
      _updateArrowPosition() {
        const image = this.grid.querySelector('.c_pickup__image-wrapper');
        if (!image) return;
        const center = image.offsetTop + image.offsetHeight / 2;
        this.style.setProperty('--c_pickup-arrow-center', `${center}px`);
      }
    }
  );
}
